import React, { useState, Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createStyles,
    ActionIcon,
    Button,
    Collapse,
    Select,
    TextInput,
    NumberInput,
    Switch,
    Radio,
    SegmentedControl,
    Card,
    Paper,
    Avatar,
    Group,
    TypographyStylesProvider,
    Text
} from '@mantine/core';
import {
    DatePicker,
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
  IconBell,
  IconSettings,
  IconUsers,
  IconFileSettings,
  IconUserPlus,
  IconGavel,
  IconBuildingBank,
  IconRepeat,
  IconReceiptRefund,
  IconReceipt,
  IconReceiptTax,
  IconReport,
  IconCashBanknote,
  IconBook,
  IconCalendar,
  IconMessage,
} from '@tabler/icons';


import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
    fetchTests,
    testPost,
    testUpload,
    selectImage
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';
import { 
    fieldInfoUpdated,
    selectSectionData,
} from '../features/home/homeSlice';
//descript:here for upload tests
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    },
    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
    
}));


//needed: pass params to fill out the areas of the alert item
//export function AlertItem {
const AlertItem = ({par, alertTime, msg}) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    
    console.log(par)
    console.log(alertTime)
    console.log(msg)
    const component_md = {
        par: 'alert',
        lvl: 0,
        child: 'new',
        section: 'newSection',
    }
    const avail_parents = [
        { title: 'Alerts', item: 'alerts_5', icon: IconBell, color: 'violet' },//
        { title: 'Account Settings', item: 'accnt_settings_5', icon: IconSettings, color: 'indigo' },//
        { title: 'Subscribers', item: 'subscribers_5', icon: IconUserPlus, color: 'blue' },
        { title: 'Schedule', item: 'schedule_5', icon: IconCalendar, color: 'teal' },
        { title: 'Auctions', item: 'auctions_5', icon: IconGavel, color: 'cyan' },
        { title: 'Reports', item: 'reports_5', icon: IconReport, color: 'pink' },
        { title: 'Business Mgmt', item: 'biz_mgmt_5', icon: IconFileSettings, color: 'orange' },
        { title: 'Staff', item: 'staff_5', icon: IconUsers, color: 'green' },
        { title: 'Docs', item: 'docs_5', icon: IconBook, color: 'grey' },
        { title: 'Msgs', item: 'msgs_5', icon: IconMessage, color: 'black' },
    ];
    let matched_idx = -1;
    for (let i = 0; i < avail_parents.length; i++ ){
        if (avail_parents[i].item == par){
            matched_idx = i;
        }
    }
    console.log(matched_idx)
    const matchedIcon = avail_parents[matched_idx];
    const alertTitle = avail_parents[matched_idx].title;
    console.log(avail_parents[matched_idx].title)



    return (
        <>
                <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Group>
                            <Avatar alt={par} radius="xl" >
                                <matchedIcon.icon color={avail_parents[matched_idx].color} size="1.5em" />
                            </Avatar>
                                <Text fz="sm">{alertTitle}</Text>
                                <Text fz="xs" c="dimmed">
                                    {alertTime}
                                </Text>
                        </Group>
                        <TypographyStylesProvider className={classes.body}>
                            <div className={classes.content} dangerouslySetInnerHTML={{ __html: msg }} />
                        </TypographyStylesProvider>
                    <br/>
                </Card>
        </>
    );
    
}
export default AlertItem
